// Textos FIJOS de la interfaz (el contenido del Camino llega ya traducido desde la API).
// El español es la referencia: `en` y `fr` deben tener exactamente las mismas claves
// (lo comprueba TypeScript). `{nombre}` se sustituye al traducir.

export const es = {
	'app.name': 'Guardianes del Camino',
	'app.tagline': 'Cuida los árboles del Camino de la Veracruz',

	'nav.map': 'Mapa',
	'nav.stages': 'Etapas',
	'nav.learn': 'Formación',
	'nav.more': 'Más',

	'common.loading': 'Cargando…',
	'common.retry': 'Reintentar',
	'common.back': 'Volver',
	'common.close': 'Cerrar',
	'common.offline': 'Sin conexión. Revisa la cobertura y vuelve a intentarlo.',
	'common.error': 'No hemos podido cargar esta información.',
	'common.language': 'Idioma',
	'common.notFound': 'Esta página no existe.',
	'common.goHome': 'Ir al mapa',

	'condition.healthy': 'Sano',
	'condition.dry': 'Seco',
	'condition.needs_pruning': 'Necesita poda',
	'condition.damaged': 'Dañado',
	'condition.none': 'Sin avisos todavía',
	'condition.reportedOn': 'Último aviso: {date}',

	'tree.notFound': 'No encontramos este árbol. Puede que el código no sea correcto o que ya no esté en el Camino.',
	'tree.code': 'Árbol {code}',
	'tree.species': 'Especie',
	'tree.municipality': 'Municipio',
	'tree.stage': 'Etapa',
	'tree.plantedAt': 'Plantado el {date}',
	'tree.approximateLocation': 'Ubicación aproximada (según los datos de plantación)',
	'tree.howIsIt': '¿Cómo ves este árbol?',
	'tree.howIsItHint': 'Tu aviso ayuda a la asociación a cuidarlo.',
	'tree.aboutSpecies': 'Conoce esta especie',

	'report.title': '¿Cómo has encontrado el árbol {code}?',
	'report.condition': 'Estado del árbol',
	'report.photo': 'Añadir una foto (opcional)',
	'report.photoSelected': 'Foto añadida',
	'report.removePhoto': 'Quitar la foto',
	'report.location': 'Añadir mi ubicación (opcional)',
	'report.locationAdded': 'Ubicación añadida',
	'report.locationUnavailable': 'No hemos podido obtener tu ubicación. Puedes enviar el aviso sin ella.',
	'report.submit': 'Enviar aviso',
	'report.sending': 'Enviando…',
	'report.chooseCondition': 'Elige cómo está el árbol.',
	'report.thanks': '¡Gracias por cuidar este árbol!',
	'report.thanksDetail': 'Tu aviso ya está en manos de la asociación.',
	'report.replaced': 'Hemos actualizado tu aviso de hoy sobre este árbol.',
	'report.backToTree': 'Volver al árbol',
	'report.error': 'No se ha podido enviar el aviso. Inténtalo de nuevo.',
	'report.privacy': 'No pedimos tus datos. La foto se guarda sin la información de tu móvil.',
	'map.label': 'Mapa del Camino con los árboles y los puntos de interés',
	'map.legend': 'Leyenda',
	'map.legendOpen': 'Ver la leyenda del mapa',
	'map.poi': 'Lugar de interés',
	'map.variant': 'Variante propuesta',
	'map.variantText': 'Este pueblo quiere sumarse al Camino. Todavía no forma parte del recorrido ni de sus etapas.',
	'map.cluster': 'Grupo (toca para ver)',
	'map.clusterAlerts': 'Árboles con avisos',
	'map.viewTree': 'Ver el árbol',
	'map.close': 'Cerrar',
	'map.unavailable':
		'Tu navegador no puede mostrar el mapa. Puedes consultar las etapas y los árboles desde las otras secciones.',

	'stages.title': 'Etapas',
	'stages.myWay': 'Mi Camino',
	'stages.progress': '{done} de {total} etapas completadas',
	'stages.progressKm': '{done} de {total} km',
	'stages.progressHint': 'Entra en una etapa para marcarla como completada.',
	'stages.allDone': 'Has completado todas las etapas.',
	'stages.empty': 'Todavía no hay etapas publicadas.',
	'stages.number': 'Etapa {n}',
	'stages.distance': '{km} km',
	'stages.markDone': 'Marcar como completada',
	'stages.undo': 'Desmarcar',
	'stages.done': 'Completada',
	'stages.doneOn': 'Completada el {date}',
	'stages.notFound': 'No encontramos esta etapa.',
	'stages.places': 'Localidades',
	'stages.inMunicipality': 'Municipio de {name}',
	'stages.heritage': 'Patrimonio',
	'stages.traditions': 'Tradiciones',
	'stages.pointsOfInterest': 'Lugares de interés',
	'stages.moreInfo': 'Más en Visit Camino de la Vera Cruz',

	'map.viewPlace': 'Ver el lugar',
	'map.stages': 'Etapas',
	'map.chooseStage': 'Elige una etapa',
	'map.wholeWay': 'Todo el Camino',
	'map.stageOf': 'Etapa {n} de {total}',
	'map.prevStage': 'Etapa anterior',
	'map.nextStage': 'Etapa siguiente',
	'map.viewStage': 'Ver la etapa',
	'map.toStart': 'Cómo llegar a la salida',
	'map.changeStage': 'Etapa {n}: {name}. Cambiar de etapa',
	'map.stageDetails': 'Ver los detalles de la etapa',
	'map.stageCounts': 'Lugares de interés: {pois} · Árboles: {trees}',
	'map.start': 'Salida',
	'map.finish': 'Llegada',
	'stages.viewOnMap': 'Ver en el mapa',
	'places.notFound': 'No encontramos este lugar.',
	'places.viewOnMap': 'Ver en el mapa',
	'places.directions': 'Cómo llegar',
	'places.photo': 'Foto {n} de {total}',
	'places.inStage': 'En la etapa {n}',
	'learn.title': 'Aula de Naturaleza',
	'learn.intro': 'Conoce las especies que se han plantado a lo largo del Camino y por qué se eligieron.',
	'learn.species': 'Especies del Camino',
	'learn.speciesEmpty': 'Todavía no hay especies publicadas.',
	'learn.search': 'Buscar especie',
	'learn.searchPlaceholder': 'Nombre, nombre científico o comunidad',
	'learn.searchClear': 'Borrar la búsqueda',
	'learn.searchCount': '{n} de {total} especies',
	'learn.searchEmpty': 'Ninguna especie coincide con «{query}».',
	'learn.mediaTitle': 'Audioguías y vídeos',
	'learn.mediaSoon': 'Próximamente',
	'learn.mediaText':
		'Pronto podrás escuchar audioguías mientras caminas y ver vídeos prácticos sobre los árboles del Camino.',
	'species.notFound': 'No encontramos esta especie.',
	'species.characteristics': 'Características',
	'species.plantingZone': 'Dónde se planta',
	'species.symbology': 'Simbología',
	'species.culturalReferences': 'Referencias culturales',
	'species.regions': 'Comunidades autónomas',
	'species.noRegionTexts': 'Todavía no hay información de esta especie en esta comunidad.',
	'more.title': 'Más',
	'more.gallery': 'Galería de fotos',
	'more.galleryHint': 'Los lugares de interés del Camino en imágenes',
	'more.webs': 'Webs del Camino',
	'more.visitHint': 'Turismo, localidades y alojamiento',
	'more.reforestationHint': 'El proyecto de reforestación y cómo apadrinar un árbol',
	'more.association': 'Para la asociación',
	'more.panel': 'Panel de seguimiento',
	'more.panelHint': 'Acceso del personal con correo y contraseña',
	'more.magic': 'Proponer un lugar mágico',
	'more.magicHint': 'Un rincón del Camino que te haya parecido especial',
	'magic.title': 'Proponer un lugar mágico',
	'magic.intro':
		'¿Has encontrado un rincón especial en el Camino? Cuéntanos cómo se llama, haz una foto y dinos dónde está.',
	'magic.name': 'Nombre del lugar',
	'magic.namePlaceholder': 'Por ejemplo, Fuente del Ermitaño',
	'magic.photo': 'Añadir una foto',
	'magic.photoSelected': 'Foto añadida',
	'magic.removePhoto': 'Quitar la foto',
	'magic.location': 'Añadir mi ubicación',
	'magic.locationAdded': 'Ubicación añadida',
	'magic.locationUnavailable':
		'No hemos podido obtener tu ubicación. Activa la ubicación del móvil y vuelve a intentarlo.',
	'magic.privacy': 'No pedimos tus datos. La foto se guarda sin la información de tu móvil.',
	'magic.submit': 'Enviar propuesta',
	'magic.sending': 'Enviando…',
	'magic.missing': 'Hacen falta el nombre, la foto y tu ubicación.',
	'magic.thanks': '¡Gracias por compartir este lugar!',
	'magic.thanksDetail': 'La asociación revisará tu propuesta.',
	'magic.back': 'Volver',
	'magic.error': 'No se ha podido enviar la propuesta. Inténtalo de nuevo.',
	'gallery.title': 'Galería',
	'gallery.empty': 'Todavía no hay fotos de los lugares del Camino.',

	'scan.open': 'Escanear árbol',
	'map.magicPlace': 'Lugar mágico',
	'scan.title': 'Escanear el QR de un árbol',
	'scan.close': 'Cerrar el escáner',
	'scan.hint': 'Acerca la cámara al código QR que hay junto al árbol',
	'scan.starting': 'Abriendo la cámara…',
	'scan.denied':
		'No tenemos permiso para usar la cámara. Puedes darlo en los ajustes del navegador o escribir el código del árbol.',
	'scan.unavailable': 'No podemos usar la cámara en este móvil. Escribe el código del árbol.',
	'scan.notATree': 'Ese código QR no es de un árbol del Camino.',
	'scan.manual': '¿No funciona? Escribe el código del árbol',
	'scan.codeLabel': 'Código del árbol',
	'scan.go': 'Ver el árbol',
	'scan.invalidCode': 'Revisa el código: lleva letras, números y guiones, como VC-0123.',

	'poi.heritage': 'Patrimonio',
	'poi.singular_space': 'Espacio singular',
	'poi.magic_place': 'Lugar mágico',

	'panel.title': 'Panel de seguimiento',
	'panel.hello': 'Hola, {name}',
	'panel.signOut': 'Cerrar sesión',
	'panel.sections': 'Secciones del panel',
	'panel.summary': 'Resumen',
	'panel.trees': 'Árboles',
	'panel.reports': 'Avisos',
	'panel.magic': 'Lugares',
	'magic.status.received': 'Recibido',
	'magic.status.approved': 'Aprobado',
	'magic.status.retired': 'Retirado',
	'magic.approve': 'Aprobar',
	'magic.retire': 'Retirar',
	'magic.delete': 'Eliminar',
	'magic.deleteConfirm': '¿Eliminar este lugar mágico y su foto? No se puede deshacer.',
	'magic.deleteYes': 'Sí, eliminar',
	'magic.cancel': 'Cancelar',
	'magic.actionError': 'No se ha podido hacer el cambio. Inténtalo de nuevo.',
	'magic.anonymous': 'Caminante: {id}',
	'magic.noAnonymous': 'Sin identificador de caminante',
	'magic.language': 'Enviado en: {lang}',
	'magic.all': 'Todos',
	'magic.filter': 'Filtrar por estado',
	'magic.empty': 'No hay lugares mágicos con este filtro.',
	'magic.count': '{count} lugares mágicos',
	'magic.viewOnMap': 'Ver en el mapa',
	'magic.photoAlt': 'Foto de {name}',

	'login.title': 'Acceso para la asociación',
	'login.hint': 'Entra con el correo y la contraseña que te ha dado el equipo del proyecto.',
	'login.email': 'Correo electrónico',
	'login.password': 'Contraseña',
	'login.submit': 'Entrar',
	'login.sending': 'Entrando…',
	'login.missing': 'Escribe el correo y la contraseña.',
	'login.invalid': 'El correo o la contraseña no son correctos.',
	'login.tooMany': 'Demasiados intentos. Espera unos minutos y vuelve a probar.',
	'login.error': 'No se ha podido entrar. Inténtalo de nuevo.',

	'health.title': 'Estado del arbolado',
	'health.hint': 'Cada árbol cuenta en el estado de su último aviso.',
	'health.total': '{count} árboles en el Camino',

	'participation.title': 'Participación',
	'participation.hint': 'Avisos por semana en las últimas 12 semanas.',
	'participation.week': 'Semana del {date}',
	'participation.period': 'Semana',
	'participation.reports': 'Avisos',
	'participation.participants': 'Participantes',
	'participation.trees': 'Árboles avisados',
	'participation.total': '{reports} avisos de {participants} participantes',
	'participation.empty': 'Todavía no hay avisos en este periodo.',
	'participation.table': 'Ver los datos en una tabla',

	'activity.title': 'Actividad por municipio',
	'activity.hint': 'Últimos 30 días.',
	'activity.municipality': 'Municipio',
	'activity.unknown': 'Municipio sin nombre',
	'activity.empty': 'Ningún aviso en los últimos 30 días.',

	'trees.filter': 'Filtrar por estado',
	'trees.all': 'Todos',
	'trees.count': '{count} árboles',
	'trees.empty': 'Ningún árbol con este estado.',

	'reports.count': '{count} avisos',
	'reports.empty': 'No hay avisos con este estado.',
	'reports.channel.qr': 'Escaneando el QR',
	'reports.channel.map': 'Desde el mapa',
	'reports.photo': 'Foto del aviso sobre el árbol {code}',
	'reports.location': 'Ver dónde se hizo',
	'reports.noLocation': 'Sin ubicación',

	'history.title': 'Avisos del árbol {code}',
	'history.retired': 'Este árbol ya no está publicado en el Camino.',
	'history.empty': 'Este árbol todavía no tiene avisos.',
	'history.notFound': 'No existe ningún árbol con el código {code}.',
	'history.publicPage': 'Ver la ficha pública',

	'pager.label': 'Páginas',
	'pager.previous': 'Anterior',
	'pager.next': 'Siguiente',
	'pager.status': 'Página {page} de {pages}',
} as const

export type MessageKey = keyof typeof es
export type Messages = Record<MessageKey, string>

export const en: Messages = {
	'app.name': 'Guardians of the Way',
	'app.tagline': 'Look after the trees of the Way of the Vera Cruz',

	'nav.map': 'Map',
	'nav.stages': 'Stages',
	'nav.learn': 'Learning',
	'nav.more': 'More',

	'common.loading': 'Loading…',
	'common.retry': 'Try again',
	'common.back': 'Back',
	'common.close': 'Close',
	'common.offline': 'No connection. Check your signal and try again.',
	'common.error': 'We could not load this information.',
	'common.language': 'Language',
	'common.notFound': 'This page does not exist.',
	'common.goHome': 'Go to the map',

	'condition.healthy': 'Healthy',
	'condition.dry': 'Dry',
	'condition.needs_pruning': 'Needs pruning',
	'condition.damaged': 'Damaged',
	'condition.none': 'No reports yet',
	'condition.reportedOn': 'Last report: {date}',

	'tree.notFound': 'We could not find this tree. The code may be wrong, or it may no longer be on the Way.',
	'tree.code': 'Tree {code}',
	'tree.species': 'Species',
	'tree.municipality': 'Municipality',
	'tree.stage': 'Stage',
	'tree.plantedAt': 'Planted on {date}',
	'tree.approximateLocation': 'Approximate location (from planting records)',
	'tree.howIsIt': 'How does this tree look?',
	'tree.howIsItHint': 'Your report helps the association look after it.',
	'tree.aboutSpecies': 'Learn about this species',

	'report.title': 'How did you find tree {code}?',
	'report.condition': 'Condition of the tree',
	'report.photo': 'Add a photo (optional)',
	'report.photoSelected': 'Photo added',
	'report.removePhoto': 'Remove photo',
	'report.location': 'Add my location (optional)',
	'report.locationAdded': 'Location added',
	'report.locationUnavailable': 'We could not get your location. You can send the report without it.',
	'report.submit': 'Send report',
	'report.sending': 'Sending…',
	'report.chooseCondition': 'Choose how the tree looks.',
	'report.thanks': 'Thank you for looking after this tree!',
	'report.thanksDetail': 'Your report is now with the association.',
	'report.replaced': 'We have updated your report on this tree for today.',
	'report.backToTree': 'Back to the tree',
	'report.error': 'The report could not be sent. Please try again.',
	'report.privacy': 'We do not ask for your details. The photo is stored without your phone’s information.',
	'map.label': 'Map of the Way with its trees and points of interest',
	'map.legend': 'Legend',
	'map.legendOpen': 'Show the map legend',
	'map.poi': 'Point of interest',
	'map.variant': 'Proposed variant',
	'map.variantText': 'This town would like to join the Way. It is not yet part of the route or its stages.',
	'map.cluster': 'Group (tap to open)',
	'map.clusterAlerts': 'Trees with reports',
	'map.viewTree': 'View the tree',
	'map.close': 'Close',
	'map.unavailable': 'Your browser cannot show the map. You can browse stages and trees from the other sections.',

	'stages.title': 'Stages',
	'stages.myWay': 'My Way',
	'stages.progress': '{done} of {total} stages completed',
	'stages.progressKm': '{done} of {total} km',
	'stages.progressHint': 'Open a stage to mark it as completed.',
	'stages.allDone': 'You have completed every stage.',
	'stages.empty': 'No stages have been published yet.',
	'stages.number': 'Stage {n}',
	'stages.distance': '{km} km',
	'stages.markDone': 'Mark as completed',
	'stages.undo': 'Undo',
	'stages.done': 'Completed',
	'stages.doneOn': 'Completed on {date}',
	'stages.notFound': 'We could not find this stage.',
	'stages.places': 'Towns and villages',
	'stages.inMunicipality': 'Municipality of {name}',
	'stages.heritage': 'Heritage',
	'stages.traditions': 'Traditions',
	'stages.pointsOfInterest': 'Places of interest',
	'stages.moreInfo': 'More on Visit Camino de la Vera Cruz',

	'map.viewPlace': 'View the place',
	'map.stages': 'Stages',
	'map.chooseStage': 'Choose a stage',
	'map.wholeWay': 'The whole Way',
	'map.stageOf': 'Stage {n} of {total}',
	'map.prevStage': 'Previous stage',
	'map.nextStage': 'Next stage',
	'map.viewStage': 'View the stage',
	'map.toStart': 'Directions to the start',
	'map.changeStage': 'Stage {n}: {name}. Change stage',
	'map.stageDetails': 'Show the stage details',
	'map.stageCounts': 'Places of interest: {pois} · Trees: {trees}',
	'map.start': 'Start',
	'map.finish': 'Finish',
	'stages.viewOnMap': 'View on the map',
	'places.notFound': 'We could not find this place.',
	'places.viewOnMap': 'View on the map',
	'places.directions': 'Get directions',
	'places.photo': 'Photo {n} of {total}',
	'places.inStage': 'On stage {n}',
	'learn.title': 'Nature Classroom',
	'learn.intro': 'Get to know the species planted along the Way and why they were chosen.',
	'learn.species': 'Species of the Way',
	'learn.speciesEmpty': 'No species have been published yet.',
	'learn.search': 'Search species',
	'learn.searchPlaceholder': 'Name, scientific name or region',
	'learn.searchClear': 'Clear search',
	'learn.searchCount': '{n} of {total} species',
	'learn.searchEmpty': 'No species match “{query}”.',
	'learn.mediaTitle': 'Audio guides and videos',
	'learn.mediaSoon': 'Coming soon',
	'learn.mediaText':
		'Soon you will be able to listen to audio guides while you walk and watch practical videos about the trees of the Way.',
	'species.notFound': 'We could not find this species.',
	'species.characteristics': 'Characteristics',
	'species.plantingZone': 'Where it is planted',
	'species.symbology': 'Symbolism',
	'species.culturalReferences': 'Cultural references',
	'species.regions': 'Autonomous communities',
	'species.noRegionTexts': 'There is no information on this species in this region yet.',
	'more.title': 'More',
	'more.gallery': 'Photo gallery',
	'more.galleryHint': 'The places of interest of the Way in pictures',
	'more.webs': 'Websites of the Way',
	'more.visitHint': 'Tourism, towns and accommodation',
	'more.reforestationHint': 'The reforestation project and how to sponsor a tree',
	'more.association': 'For the association',
	'more.panel': 'Monitoring dashboard',
	'more.panelHint': 'Staff sign-in with email and password',
	'more.magic': 'Suggest a magical place',
	'more.magicHint': 'A spot on the Way that felt special to you',
	'magic.title': 'Suggest a magical place',
	'magic.intro': 'Found a special spot on the Way? Tell us its name, take a photo and share where it is.',
	'magic.name': 'Name of the place',
	'magic.namePlaceholder': 'For example, Hermit’s Spring',
	'magic.photo': 'Add a photo',
	'magic.photoSelected': 'Photo added',
	'magic.removePhoto': 'Remove photo',
	'magic.location': 'Add my location',
	'magic.locationAdded': 'Location added',
	'magic.locationUnavailable': 'We could not get your location. Turn on location on your phone and try again.',
	'magic.privacy': 'We don’t ask for your details. The photo is saved without your phone’s information.',
	'magic.submit': 'Send suggestion',
	'magic.sending': 'Sending…',
	'magic.missing': 'We need the name, the photo and your location.',
	'magic.thanks': 'Thank you for sharing this place!',
	'magic.thanksDetail': 'The association will review your suggestion.',
	'magic.back': 'Back',
	'magic.error': 'The suggestion could not be sent. Please try again.',
	'gallery.title': 'Gallery',
	'gallery.empty': 'There are no photos of the places of the Way yet.',

	'scan.open': 'Scan a tree',
	'map.magicPlace': 'Magical place',
	'scan.title': 'Scan a tree’s QR code',
	'scan.close': 'Close the scanner',
	'scan.hint': 'Point the camera at the QR code next to the tree',
	'scan.starting': 'Opening the camera…',
	'scan.denied':
		'We are not allowed to use the camera. You can allow it in your browser settings or type the tree code.',
	'scan.unavailable': 'We cannot use the camera on this phone. Type the tree code instead.',
	'scan.notATree': 'That QR code is not for a tree on the Way.',
	'scan.manual': 'Not working? Type the tree code',
	'scan.codeLabel': 'Tree code',
	'scan.go': 'View the tree',
	'scan.invalidCode': 'Check the code: it has letters, numbers and dashes, like VC-0123.',

	'poi.heritage': 'Heritage',
	'poi.singular_space': 'Remarkable place',
	'poi.magic_place': 'Magic place',

	'panel.title': 'Monitoring dashboard',
	'panel.hello': 'Hello, {name}',
	'panel.signOut': 'Sign out',
	'panel.sections': 'Dashboard sections',
	'panel.summary': 'Summary',
	'panel.trees': 'Trees',
	'panel.reports': 'Reports',
	'panel.magic': 'Places',
	'magic.status.received': 'Received',
	'magic.status.approved': 'Approved',
	'magic.status.retired': 'Withdrawn',
	'magic.approve': 'Approve',
	'magic.retire': 'Withdraw',
	'magic.delete': 'Delete',
	'magic.deleteConfirm': 'Delete this magical place and its photo? This cannot be undone.',
	'magic.deleteYes': 'Yes, delete',
	'magic.cancel': 'Cancel',
	'magic.actionError': 'The change could not be made. Please try again.',
	'magic.anonymous': 'Walker: {id}',
	'magic.noAnonymous': 'No walker identifier',
	'magic.language': 'Sent in: {lang}',
	'magic.all': 'All',
	'magic.filter': 'Filter by status',
	'magic.empty': 'No magical places match this filter.',
	'magic.count': '{count} magical places',
	'magic.viewOnMap': 'View on map',
	'magic.photoAlt': 'Photo of {name}',

	'login.title': 'Association access',
	'login.hint': 'Sign in with the email and password the project team gave you.',
	'login.email': 'Email',
	'login.password': 'Password',
	'login.submit': 'Sign in',
	'login.sending': 'Signing in…',
	'login.missing': 'Enter your email and password.',
	'login.invalid': 'The email or password is not correct.',
	'login.tooMany': 'Too many attempts. Wait a few minutes and try again.',
	'login.error': 'We could not sign you in. Please try again.',

	'health.title': 'Condition of the trees',
	'health.hint': 'Each tree counts in the condition of its latest report.',
	'health.total': '{count} trees on the Way',

	'participation.title': 'Participation',
	'participation.hint': 'Reports per week over the last 12 weeks.',
	'participation.week': 'Week of {date}',
	'participation.period': 'Week',
	'participation.reports': 'Reports',
	'participation.participants': 'Participants',
	'participation.trees': 'Trees reported',
	'participation.total': '{reports} reports from {participants} participants',
	'participation.empty': 'No reports in this period yet.',
	'participation.table': 'See the data as a table',

	'activity.title': 'Activity by municipality',
	'activity.hint': 'Last 30 days.',
	'activity.municipality': 'Municipality',
	'activity.unknown': 'Unnamed municipality',
	'activity.empty': 'No reports in the last 30 days.',

	'trees.filter': 'Filter by condition',
	'trees.all': 'All',
	'trees.count': '{count} trees',
	'trees.empty': 'No trees in this condition.',

	'reports.count': '{count} reports',
	'reports.empty': 'No reports in this condition.',
	'reports.channel.qr': 'Scanning the QR code',
	'reports.channel.map': 'From the map',
	'reports.photo': 'Photo of the report on tree {code}',
	'reports.location': 'See where it was sent',
	'reports.noLocation': 'No location',

	'history.title': 'Reports on tree {code}',
	'history.retired': 'This tree is no longer published on the Way.',
	'history.empty': 'This tree has no reports yet.',
	'history.notFound': 'There is no tree with code {code}.',
	'history.publicPage': 'See the public page',

	'pager.label': 'Pages',
	'pager.previous': 'Previous',
	'pager.next': 'Next',
	'pager.status': 'Page {page} of {pages}',
}

export const fr: Messages = {
	'app.name': 'Gardiens du Chemin',
	'app.tagline': 'Prenez soin des arbres du Chemin de la Vera Cruz',

	'nav.map': 'Carte',
	'nav.stages': 'Étapes',
	'nav.learn': 'Formation',
	'nav.more': 'Plus',

	'common.loading': 'Chargement…',
	'common.retry': 'Réessayer',
	'common.back': 'Retour',
	'common.close': 'Fermer',
	'common.offline': 'Pas de connexion. Vérifiez le réseau et réessayez.',
	'common.error': 'Impossible de charger ces informations.',
	'common.language': 'Langue',
	'common.notFound': 'Cette page n’existe pas.',
	'common.goHome': 'Aller à la carte',

	'condition.healthy': 'En bonne santé',
	'condition.dry': 'Sec',
	'condition.needs_pruning': 'À tailler',
	'condition.damaged': 'Abîmé',
	'condition.none': 'Aucun signalement pour l’instant',
	'condition.reportedOn': 'Dernier signalement : {date}',

	'tree.notFound':
		'Nous ne trouvons pas cet arbre. Le code est peut-être erroné, ou l’arbre n’est plus sur le Chemin.',
	'tree.code': 'Arbre {code}',
	'tree.species': 'Espèce',
	'tree.municipality': 'Commune',
	'tree.stage': 'Étape',
	'tree.plantedAt': 'Planté le {date}',
	'tree.approximateLocation': 'Emplacement approximatif (selon les données de plantation)',
	'tree.howIsIt': 'Comment voyez-vous cet arbre ?',
	'tree.howIsItHint': 'Votre signalement aide l’association à en prendre soin.',
	'tree.aboutSpecies': 'Découvrir cette espèce',

	'report.title': 'Dans quel état avez-vous trouvé l’arbre {code} ?',
	'report.condition': 'État de l’arbre',
	'report.photo': 'Ajouter une photo (facultatif)',
	'report.photoSelected': 'Photo ajoutée',
	'report.removePhoto': 'Retirer la photo',
	'report.location': 'Ajouter ma position (facultatif)',
	'report.locationAdded': 'Position ajoutée',
	'report.locationUnavailable': 'Impossible d’obtenir votre position. Vous pouvez envoyer le signalement sans elle.',
	'report.submit': 'Envoyer le signalement',
	'report.sending': 'Envoi…',
	'report.chooseCondition': 'Choisissez l’état de l’arbre.',
	'report.thanks': 'Merci de prendre soin de cet arbre !',
	'report.thanksDetail': 'Votre signalement est entre les mains de l’association.',
	'report.replaced': 'Nous avons mis à jour votre signalement du jour pour cet arbre.',
	'report.backToTree': 'Retour à l’arbre',
	'report.error': 'Le signalement n’a pas pu être envoyé. Réessayez.',
	'report.privacy':
		'Nous ne demandons pas vos données. La photo est enregistrée sans les informations de votre téléphone.',
	'map.label': 'Carte du Chemin avec ses arbres et ses points d’intérêt',
	'map.legend': 'Légende',
	'map.legendOpen': 'Voir la légende de la carte',
	'map.poi': 'Lieu d’intérêt',
	'map.variant': 'Variante proposée',
	'map.variantText':
		'Ce village souhaite rejoindre le Chemin. Il ne fait pas encore partie du parcours ni de ses étapes.',
	'map.cluster': 'Groupe (touchez pour ouvrir)',
	'map.clusterAlerts': 'Arbres signalés',
	'map.viewTree': 'Voir l’arbre',
	'map.close': 'Fermer',
	'map.unavailable':
		'Votre navigateur ne peut pas afficher la carte. Vous pouvez consulter les étapes et les arbres depuis les autres sections.',

	'stages.title': 'Étapes',
	'stages.myWay': 'Mon Chemin',
	'stages.progress': '{done} étapes terminées sur {total}',
	'stages.progressKm': '{done} km sur {total}',
	'stages.progressHint': 'Ouvrez une étape pour la marquer comme terminée.',
	'stages.allDone': 'Vous avez terminé toutes les étapes.',
	'stages.empty': 'Aucune étape n’est encore publiée.',
	'stages.number': 'Étape {n}',
	'stages.distance': '{km} km',
	'stages.markDone': 'Marquer comme terminée',
	'stages.undo': 'Annuler',
	'stages.done': 'Terminée',
	'stages.doneOn': 'Terminée le {date}',
	'stages.notFound': 'Nous n’avons pas trouvé cette étape.',
	'stages.places': 'Localités',
	'stages.inMunicipality': 'Commune de {name}',
	'stages.heritage': 'Patrimoine',
	'stages.traditions': 'Traditions',
	'stages.pointsOfInterest': 'Lieux d’intérêt',
	'stages.moreInfo': 'En savoir plus sur Visit Camino de la Vera Cruz',

	'map.viewPlace': 'Voir le lieu',
	'map.stages': 'Étapes',
	'map.chooseStage': 'Choisissez une étape',
	'map.wholeWay': 'Tout le Chemin',
	'map.stageOf': 'Étape {n} sur {total}',
	'map.prevStage': 'Étape précédente',
	'map.nextStage': 'Étape suivante',
	'map.viewStage': 'Voir l’étape',
	'map.toStart': 'Itinéraire jusqu’au départ',
	'map.changeStage': 'Étape {n} : {name}. Changer d’étape',
	'map.stageDetails': 'Voir les détails de l’étape',
	'map.stageCounts': 'Lieux d’intérêt : {pois} · Arbres : {trees}',
	'map.start': 'Départ',
	'map.finish': 'Arrivée',
	'stages.viewOnMap': 'Voir sur la carte',
	'places.notFound': 'Nous n’avons pas trouvé ce lieu.',
	'places.viewOnMap': 'Voir sur la carte',
	'places.directions': 'Itinéraire',
	'places.photo': 'Photo {n} sur {total}',
	'places.inStage': 'Sur l’étape {n}',
	'learn.title': 'Classe nature',
	'learn.intro': 'Découvrez les espèces plantées le long du Chemin et pourquoi elles ont été choisies.',
	'learn.species': 'Espèces du Chemin',
	'learn.speciesEmpty': 'Aucune espèce n’est encore publiée.',
	'learn.search': 'Rechercher une espèce',
	'learn.searchPlaceholder': 'Nom, nom scientifique ou région',
	'learn.searchClear': 'Effacer la recherche',
	'learn.searchCount': '{n} espèces sur {total}',
	'learn.searchEmpty': 'Aucune espèce ne correspond à « {query} ».',
	'learn.mediaTitle': 'Audioguides et vidéos',
	'learn.mediaSoon': 'Bientôt',
	'learn.mediaText':
		'Bientôt, vous pourrez écouter des audioguides en marchant et regarder des vidéos pratiques sur les arbres du Chemin.',
	'species.notFound': 'Nous n’avons pas trouvé cette espèce.',
	'species.characteristics': 'Caractéristiques',
	'species.plantingZone': 'Où elle est plantée',
	'species.symbology': 'Symbolique',
	'species.culturalReferences': 'Références culturelles',
	'species.regions': 'Communautés autonomes',
	'species.noRegionTexts': 'Il n’y a pas encore d’informations sur cette espèce dans cette région.',
	'more.title': 'Plus',
	'more.gallery': 'Galerie photos',
	'more.galleryHint': 'Les lieux d’intérêt du Chemin en images',
	'more.webs': 'Sites du Chemin',
	'more.visitHint': 'Tourisme, localités et hébergement',
	'more.reforestationHint': 'Le projet de reboisement et comment parrainer un arbre',
	'more.association': 'Pour l’association',
	'more.panel': 'Tableau de suivi',
	'more.panelHint': 'Accès du personnel avec e-mail et mot de passe',
	'more.magic': 'Proposer un lieu magique',
	'more.magicHint': 'Un coin du Chemin qui vous a semblé spécial',
	'magic.title': 'Proposer un lieu magique',
	'magic.intro':
		'Vous avez trouvé un coin spécial sur le Chemin ? Dites-nous son nom, prenez une photo et indiquez où il se trouve.',
	'magic.name': 'Nom du lieu',
	'magic.namePlaceholder': 'Par exemple, Source de l’Ermite',
	'magic.photo': 'Ajouter une photo',
	'magic.photoSelected': 'Photo ajoutée',
	'magic.removePhoto': 'Retirer la photo',
	'magic.location': 'Ajouter ma position',
	'magic.locationAdded': 'Position ajoutée',
	'magic.locationUnavailable':
		'Nous n’avons pas pu obtenir votre position. Activez la localisation de votre téléphone et réessayez.',
	'magic.privacy':
		'Nous ne demandons pas vos données. La photo est enregistrée sans les informations de votre téléphone.',
	'magic.submit': 'Envoyer la proposition',
	'magic.sending': 'Envoi…',
	'magic.missing': 'Il faut le nom, la photo et votre position.',
	'magic.thanks': 'Merci de partager ce lieu !',
	'magic.thanksDetail': 'L’association examinera votre proposition.',
	'magic.back': 'Retour',
	'magic.error': 'La proposition n’a pas pu être envoyée. Réessayez.',
	'gallery.title': 'Galerie',
	'gallery.empty': 'Il n’y a pas encore de photos des lieux du Chemin.',

	'scan.open': 'Scanner un arbre',
	'map.magicPlace': 'Lieu magique',
	'scan.title': 'Scanner le QR code d’un arbre',
	'scan.close': 'Fermer le scanner',
	'scan.hint': 'Approchez la caméra du QR code placé près de l’arbre',
	'scan.starting': 'Ouverture de la caméra…',
	'scan.denied':
		'Nous n’avons pas l’autorisation d’utiliser la caméra. Vous pouvez l’accorder dans les réglages du navigateur ou saisir le code de l’arbre.',
	'scan.unavailable': 'Impossible d’utiliser la caméra sur ce téléphone. Saisissez le code de l’arbre.',
	'scan.notATree': 'Ce QR code ne correspond pas à un arbre du Chemin.',
	'scan.manual': 'Ça ne marche pas ? Saisissez le code de l’arbre',
	'scan.codeLabel': 'Code de l’arbre',
	'scan.go': 'Voir l’arbre',
	'scan.invalidCode': 'Vérifiez le code : des lettres, des chiffres et des tirets, comme VC-0123.',

	'poi.heritage': 'Patrimoine',
	'poi.singular_space': 'Lieu remarquable',
	'poi.magic_place': 'Lieu magique',

	'panel.title': 'Tableau de suivi',
	'panel.hello': 'Bonjour, {name}',
	'panel.signOut': 'Se déconnecter',
	'panel.sections': 'Sections du tableau',
	'panel.summary': 'Résumé',
	'panel.trees': 'Arbres',
	'panel.reports': 'Signalements',
	'panel.magic': 'Lieux',
	'magic.status.received': 'Reçu',
	'magic.status.approved': 'Approuvé',
	'magic.status.retired': 'Retiré',
	'magic.approve': 'Approuver',
	'magic.retire': 'Retirer',
	'magic.delete': 'Supprimer',
	'magic.deleteConfirm': 'Supprimer ce lieu magique et sa photo ? Cette action est définitive.',
	'magic.deleteYes': 'Oui, supprimer',
	'magic.cancel': 'Annuler',
	'magic.actionError': 'La modification n’a pas pu être faite. Réessayez.',
	'magic.anonymous': 'Pèlerin : {id}',
	'magic.noAnonymous': 'Sans identifiant de pèlerin',
	'magic.language': 'Envoyé en : {lang}',
	'magic.all': 'Tous',
	'magic.filter': 'Filtrer par statut',
	'magic.empty': 'Aucun lieu magique ne correspond à ce filtre.',
	'magic.count': '{count} lieux magiques',
	'magic.viewOnMap': 'Voir sur la carte',
	'magic.photoAlt': 'Photo de {name}',

	'login.title': 'Accès pour l’association',
	'login.hint': 'Connectez-vous avec l’e-mail et le mot de passe fournis par l’équipe du projet.',
	'login.email': 'E-mail',
	'login.password': 'Mot de passe',
	'login.submit': 'Se connecter',
	'login.sending': 'Connexion…',
	'login.missing': 'Saisissez l’e-mail et le mot de passe.',
	'login.invalid': 'L’e-mail ou le mot de passe est incorrect.',
	'login.tooMany': 'Trop de tentatives. Attendez quelques minutes avant de réessayer.',
	'login.error': 'Connexion impossible. Veuillez réessayer.',

	'health.title': 'État des arbres',
	'health.hint': 'Chaque arbre compte dans l’état de son dernier signalement.',
	'health.total': '{count} arbres sur le Chemin',

	'participation.title': 'Participation',
	'participation.hint': 'Signalements par semaine sur les 12 dernières semaines.',
	'participation.week': 'Semaine du {date}',
	'participation.period': 'Semaine',
	'participation.reports': 'Signalements',
	'participation.participants': 'Participants',
	'participation.trees': 'Arbres signalés',
	'participation.total': '{reports} signalements de {participants} participants',
	'participation.empty': 'Aucun signalement sur cette période pour l’instant.',
	'participation.table': 'Voir les données sous forme de tableau',

	'activity.title': 'Activité par commune',
	'activity.hint': '30 derniers jours.',
	'activity.municipality': 'Commune',
	'activity.unknown': 'Commune sans nom',
	'activity.empty': 'Aucun signalement ces 30 derniers jours.',

	'trees.filter': 'Filtrer par état',
	'trees.all': 'Tous',
	'trees.count': '{count} arbres',
	'trees.empty': 'Aucun arbre dans cet état.',

	'reports.count': '{count} signalements',
	'reports.empty': 'Aucun signalement dans cet état.',
	'reports.channel.qr': 'En scannant le QR code',
	'reports.channel.map': 'Depuis la carte',
	'reports.photo': 'Photo du signalement sur l’arbre {code}',
	'reports.location': 'Voir d’où il a été envoyé',
	'reports.noLocation': 'Sans localisation',

	'history.title': 'Signalements de l’arbre {code}',
	'history.retired': 'Cet arbre n’est plus publié sur le Chemin.',
	'history.empty': 'Cet arbre n’a encore aucun signalement.',
	'history.notFound': 'Aucun arbre ne porte le code {code}.',
	'history.publicPage': 'Voir la fiche publique',

	'pager.label': 'Pages',
	'pager.previous': 'Précédente',
	'pager.next': 'Suivante',
	'pager.status': 'Page {page} sur {pages}',
}

export const MESSAGES = { es, en, fr } as const
